const simpleVideo = () => ({
  isDesktopPlaying: false,
  isMobilePlaying: false,
  isMobile: false,
  isVideoPlaying: false,
  hidePauseButton: false,

  init() {
    this.updateMobileFlag()
    const { thisParentContainer, desktopVideo, mobileVideo } = this.$refs

    if (desktopVideo && desktopVideo.autoplay) {
      this.isVideoPlaying = true
    }

    desktopVideo.addEventListener("ended", (event) => {
      this.isVideoPlaying = false
    })
  },

  updateMobileFlag() {
    this.isMobile = window.matchMedia("(max-width: 767px)").matches
  },

  playPauseToggle(evt) {
    const { thisParentContainer, desktopVideo, mobileVideo } = this.$refs
    const videoContainers = thisParentContainer.querySelectorAll("video")

    if (this.isVideoPlaying) {
      videoContainers.forEach((video) => {
        video.pause()
      })
      this.isVideoPlaying = false
      this.hidePauseButton = true
    } else {
      videoContainers.forEach((video) => {
        video.play()
      })
      this.isVideoPlaying = true
      this.hidePauseButton = false
    }
  },
  showPauseButtonOnHover() {
    if (this.isVideoPlaying) {
      this.hidePauseButton = false
    }
  },
  hidePauseButtonOnHover() {
    if (this.isVideoPlaying) {
      this.hidePauseButton = true
    }
  },
})

export default simpleVideo

window.addEventListener("alpine:init", ()=>{
  Alpine.data("simple_video", simpleVideo)
})
